import React, { useState } from 'react';
import './RegisterWardModal.css';

const RegisterWardModal = ({ isOpen, onClose, onAddWard }) => {
  const [newWard, setNewWard] = useState({
    wardName: '',
    location: '',
    headDoctor: '',
    staff: [],
  });
  const [newStaff, setNewStaff] = useState({ name: '', role: '' });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewWard((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleStaffInputChange = (e) => {
    const { name, value } = e.target;
    setNewStaff((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleAddStaff = () => {
    if (newStaff.name && newStaff.role) {
      setNewWard((prevState) => ({
        ...prevState,
        staff: [...prevState.staff, newStaff],
      }));
      setNewStaff({ name: '', role: '' });
    }
  };

  const handleAddWard = () => {
    if (newWard.wardName && newWard.location && newWard.headDoctor) {
      onAddWard(newWard);
      onClose();
    }
  };

  return (
    isOpen && (
      <div className="modal-overlay-registerwardmodal" onClick={onClose}>
        <div className="register-ward-modal" onClick={(e) => e.stopPropagation()}>
          <h3>Register a New Department</h3>
          <input
            type="text"
            className="input-field2"
            name="wardName"
            placeholder="Ward Name"
            value={newWard.wardName}
            onChange={handleInputChange}
          />
          <input
            type="text"
            className="input-field2"
            name="location"
            placeholder="Ex: Left wing, Block A, etc"
            value={newWard.location}
            onChange={handleInputChange}
          />
          <input
            type="text"
            className="input-field2"
            name="headDoctor"
            placeholder="Head Doctor Name"
            value={newWard.headDoctor}
            onChange={handleInputChange}
          />

          <h4>Add Staff</h4>
          <input
            type="text"
            className="input-field2"
            name="name"
            placeholder="Staff Name"
            value={newStaff.name}
            onChange={handleStaffInputChange}
          />
          <input
            type="text"
            className="input-field2"
            name="role"
            placeholder="Staff Role"
            value={newStaff.role}
            onChange={handleStaffInputChange}
          />
          <button className="add-staff-btn-registerward" onClick={handleAddStaff}>
            Add Staff
          </button>

          <div className="staff-list-registerward">
            <h5>Staff Members:</h5>
            <ul>
              {newWard.staff.map((staff, index) => (
                <li key={index}>
                  {staff.name} - {staff.role}
                </li>
              ))}
            </ul>
          </div>

          <div className="modal-actions-registerward">
            <button className="add-ward-btn-registerward" onClick={handleAddWard}>
              Add Department
            </button>
            <button className="cancel-btn-registerward" onClick={onClose}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default RegisterWardModal;
